import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  EventEmitter,
  ElementRef,
  HostListener,
  OnDestroy,
  Output,
  Type,
  ViewChild,
  ViewContainerRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { PanelLateralService } from './panel-lateral.service';
import { DeteccionCambiosService } from '../../../../infrastructure/services/deteccion-cambios.service';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import {ModalService} from '../modal/modal.service';

export type Size = 'sm' | 'md' | 'lg' | 'xl';

@Component({
  selector: 'app-panel-lateral',
  templateUrl: './panel-lateral.component.html',
  styleUrls: ['./panel-lateral.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PanelLateralComponent implements AfterViewInit, OnDestroy {
  @ViewChild('container', { read: ViewContainerRef, static: true })
  container!: ViewContainerRef;
  @ViewChild('tituloPanel') tituloPanel?: ElementRef<HTMLElement>;
  public titulo = '';
  public size: Size = 'lg';
  @Output() cargado = new EventEmitter<boolean>();

  private uiSubscription?: Subscription;
  private componentToLoadSubscription?: Subscription;

  @HostListener('document:keydown', ['$event']) onKeydownHandler(
    event: KeyboardEvent,
  ) {
    if (event.key === 'Escape' && !event.defaultPrevented && !this.modalService.isOpenValue) {
      this.panelLateralService.close();
    }
  }

  constructor(
    public panelLateralService: PanelLateralService,
    private cdr: ChangeDetectorRef,
    private detectaUIService: DeteccionCambiosService,
    private modalService: ModalService,
  ) {}

  public ngOnInit(): void {
    this.panelLateralService.setPanelLateralComponentRef(this);
  }

  public ngAfterViewInit() {
    this.componentToLoadSubscription =
      this.panelLateralService.componentToLoad$.subscribe({
        next: (component) => this.loadComponent(component),
      });
  }

  public componenteCargado() {
    this.cargado.emit(true);
  }

  public clear() {
    this.container.clear();
  }

  public loadComponent(component: Type<any>): ComponentRef<any> {
    this.container.clear();
    const componentRef = this.container.createComponent(component);
    this.panelLateralService.open();

    // Cancelar subscripción anterior si existe para evitar memory leaks
    this.uiSubscription?.unsubscribe();

    // Usar take(1) para auto-desuscribirse después de la primera emisión
    this.uiSubscription = this.detectaUIService
      .getActualizaUI$()
      .pipe(take(1))
      .subscribe(() => {
        this.cdr.markForCheck();
        setTimeout(() => {
          this.tituloPanel?.nativeElement.focus();
          this.cargado.emit(true);
        });
      });

    return componentRef;
  }

  public ngOnDestroy(): void {
    this.uiSubscription?.unsubscribe();
    this.componentToLoadSubscription?.unsubscribe();
  }
}
